import {
  base_colorHighlight,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import AiStarsIconV2 from 'ext-ui/svg/icon/AiStarsIconV2'
import BarChartIcon from 'ext-ui/svg/icon/BarChartIcon'
import LineChartIcon from 'ext-ui/svg/icon/LineChartIcon'
import PieChartIcon from 'ext-ui/svg/icon/PieChartIcon'
import TrendLineIcon from 'ext-ui/svg/icon/TrendLineIcon'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'

import styles from './InsightsChatEmptyState.style'

interface InsightsChatEmptyStateProps {
  onPromptClick: (prompt: string) => void
}

const InsightsChatEmptyState: React.FC<InsightsChatEmptyStateProps> = ({
  onPromptClick,
}) => {
  const translate = useTranslate()

  const prompts = [
    {
      title: translate(
        'Show a spending breakdown by expense category label for last quarter',
      ),
      icon: (
        <PieChartIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      // TODO: octopod-ai - currently hardcoded for ERP enabled orgs
      prompt:
        'Show a spending breakdown by expense category label for last quarter',
    },
    {
      title: translate(
        'Show my spending trend on transportation over the last 30 days',
      ),
      icon: (
        <TrendLineIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt: 'Show my spending trend on transportation over the last 30 days',
    },
    {
      title: translate(
        'Show month over month spending on meals from the last completed month',
      ),
      icon: (
        <BarChartIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt:
        'Show month over month spending on meals from the last completed month',
    },
    {
      title: translate('Show top merchant categories by spend this month'),
      icon: (
        <LineChartIcon width={16} height={16} color={text_colorTextSecondary} />
      ),
      prompt: 'Show top merchant categories by spend this month',
    },
  ]

  return (
    <div css={styles} className="InsightsChatEmptyState">
      <div className="lightning-icon">
        <AiStarsIconV2 width={32} height={32} fill={base_colorHighlight} />
      </div>
      <div className="empty-state-title">
        {translate('Get Started with AI Insights')}
      </div>
      <div className="empty-state-subtitle">
        {translate(
          "Ask me anything about your expenses and I'll create custom visualizations for you",
        )}
      </div>
      <div className="prompts-list">
        {prompts.map((prompt, index) => (
          /* TODO: octopod-ai - move this into its own component if needed */
          <button
            className={'prompt-button'}
            key={index}
            onClick={() => onPromptClick(prompt.prompt)}
          >
            <div className={'prompt-button-icon'}>{prompt.icon}</div>
            {prompt.title}
          </button>
        ))}
      </div>
    </div>
  )
}

export default InsightsChatEmptyState
